export default function () {
    return {
        title: 'Search Bar Widget',
        placeholder: 'Search',
    }
}
